import { useEffect, useRef } from "react";

interface IUseInterval {
  (callback: () => void, interval: number, isStart: boolean): void;
}

const useInterval: IUseInterval = (callback, interval, isStart) => {
  const savedCallback = useRef<(() => void) | null>(null);

  useEffect(() => {
    savedCallback.current = callback;
  });

  useEffect(() => {
    function tick() {
      if (savedCallback.current && isStart) {
        savedCallback.current();
      }
    }

    let id = setInterval(tick, interval);
    return () => clearInterval(id);
  }, [interval, isStart]);
};

export default useInterval;
